module.exports = __FOREMAN_VENDOR__REACT__;